import Head from "next/head";

import { InfoPageContainer } from "../../constants/Styles";
import { FlashPCBPage } from "../../models/page";

const FourOhFour: FlashPCBPage = () => {
  return (
    <>
      <Head>
        <title>Page not found</title>
        <meta name="description" content="404 Page not found" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <InfoPageContainer>
        There is nothing here. Try your luck on a different page!
      </InfoPageContainer>
    </>
  );
};
export default FourOhFour;
